import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'

const SummaryHeader = () => (
    <Text variant="heading3" color="grayscale_900" mb={16} mt={[40, 32]}>
        <FormattedMessage
            id="global.summary.section_caption"
            defaultMessage="Podsumowanie"
        />
    </Text>
)

export default SummaryHeader
